import {
  AddOnItem,
  AddOnItemName,
  Organization,
  OrganizationProfile,
  OrganizationVaProfile,
  VaOrganizationProfileStatus,
} from "schemas/dashboard";
import { routes } from "schemas/routes";

import { CURRENT_VA_STEP } from "utils/localStorage";

export function vaSelfServeNavigate(
  currentPathname: string,
  direction: "next" | "back",
) {
  let steps = [
    routes.welcomeSelfServeOnboarding,
    routes.aboutSelfServeOnboarding,
    routes.nicheSelfServeOnboarding,
    routes.templateSelfServeOnboarding,
    routes.faqSelfServeOnboarding,
  ];
  const currentStep = steps.findIndex((step) => currentPathname.endsWith(step));

  if (direction === "next" && currentStep < steps.length - 1) {
    return steps[currentStep + 1];
  } else if (direction === "back" && currentStep > 0) {
    return steps[currentStep - 1];
  } else {
    return currentPathname;
  }
}

export const getQuantityForItem = (
  addOnItemName: AddOnItemName,
  items: AddOnItem[],
) => {
  if (!items) return;
  const item = items.find((item) => item.itemName === addOnItemName);
  if (item) {
    return item.quantity;
  }
  return 0;
};

export const redirectToStep = (
  currentOrg: Organization,
  vaProfile: OrganizationVaProfile,
  organizationProfile: OrganizationProfile | null,
  query?: string,
) => {
  if (vaProfile?.status === VaOrganizationProfileStatus.completed) {
    if (query?.includes(`${routes.pitchTrackerImport}`)) {
      return routes.dashboard;
    }
    return routes.faqSelfServeOnboarding;
  }
  const niches = vaProfile?.niches?.filter(
    (niche) => niche.bento_category_id,
  )?.length;

  const hasNiches = niches && niches > 0;
  if (hasNiches) {
    return routes.templateSelfServeOnboarding;
  }
  const hasUgcType =
    organizationProfile?.isUgcCreator || organizationProfile?.isInfluencer;

  const currentStep = localStorage.getItem(
    `${CURRENT_VA_STEP}-${currentOrg.id}`,
  );
  if (currentStep) {
    if (!hasUgcType) {
      return routes.aboutSelfServeOnboarding;
    }
    return routes.nicheSelfServeOnboarding;
  } else {
    return routes.welcomeSelfServeOnboarding;
  }
};
